export default __webpack_public_path__ + "static/media/icon-download.89e8c712.svg";